// src/hooks/useApplyTheme.ts
import { useEffect, useContext } from "react";
import { PrimeReactContext } from "primereact/api";
import { useGetAppSettingsQuery } from "../queries/appsettings.query";

export function useApplyTheme() {
    const ctx = useContext(PrimeReactContext);
    const { data } = useGetAppSettingsQuery();

    useEffect(() => {
        if (!ctx?.changeTheme || !data?.theme) return;

        const currentHref = document.getElementById("theme-css")?.getAttribute("href");
        const currentTheme = currentHref?.split("/")[2];

        if (data.theme !== currentTheme) {
            ctx.changeTheme(currentTheme, data.theme, "theme-css", () => {
                console.log(`Theme changed from ${currentTheme} to ${data.theme}`);
            });
        }
    }, [ctx, ctx?.changeTheme, data]);
}
